export const CATEGORIES = [
  {
    id: 'veliki-formati',
    title: 'Veliki formati i outdoor',
    description: 'Štampa koja privlači pažnju na fasadama, izlozima, bilbordima i drugim vanjskim lokacijama.',
    examples: ['bilbordi', 'baneri', 'fasadne grafike', 'mesh platna', 'One Way Vision folije', 'plakati'],
    galleryId: '064.jpg',
    image: `/images/gallery/large/064.jpg`,
    alt: 'Veliki format štampe postavljen na vanjskoj lokaciji',
  },
  {
    id: 'brendiranje-prostora',
    title: 'Brendiranje prostora i objekata',
    description: 'Uredite poslovni prostor tako da odmah prenese identitet vašeg brenda.',
    examples: ['svjetleća slova', 'fasadni natpisi', 'totemi', 'zidne grafike', 'podna grafika', 'press wall', 'informativne oznake'],
    galleryId: '003.jpg',
    image: `/images/gallery/large/003.jpg`,
    alt: 'Zidna grafika sa zimskim šumskim motivom ispod reflektora',
  },
  {
    id: 'brendiranje-vozila',
    title: 'Brendiranje vozila',
    description: 'Pretvorite vozilo u pokretnu reklamu koja predstavlja vašu firmu na svakoj lokaciji.',
    examples: ['djelimično brendiranje automobila', 'kompletno brendiranje automobila', 'brendiranje kombija', 'brendiranje dostavnih vozila', 'brendiranje flote'],
    galleryId: '101.jpg',
    image: `/images/gallery/large/101.jpg`,
    alt: 'Bijeli automobil s plavom folijom i grafikom',
  },
  {
    id: 'tekstil',
    title: 'Tekstil i radna odjeća',
    description: 'Odjeća za zaposlene, sportske klubove, događaje i promotivne kampanje.',
    examples: ['majice', 'dukserice', 'polo majice', 'sportski dresovi', 'radna odjeća', 'jakne', 'kape', 'torbe'],
    galleryId: '005.jpg',
    image: `/images/gallery/large/005.jpg`,
    alt: 'Tim u dresovima s printom',
  },
  {
    id: 'event-oprema',
    title: 'Event i promotivna oprema',
    description: 'Sve što vam treba da se profesionalno predstavite na sajmu, konferenciji ili događaju.',
    examples: ['roll-up sistemi', 'beach flag zastave', 'promo pultovi', 'sajamski štandovi', 'šatori', 'zastave', 'poslovni pokloni'],
    galleryId: '014.jpg',
    image: `/images/gallery/large/014.jpg`,
    alt: 'Brendirani promotivni pult i štand na sajmu',
  },
  {
    id: 'posebna-rjesenja',
    title: 'Posebna i protokolarna rješenja',
    description: 'Izrađujemo vizuelna rješenja prema potrebama medija, institucija, galerija i posebnih projekata.',
    examples: ['scenografije', 'informativni panoi', 'zastave', 'plakete', 'medalje', 'unikatna rješenja'],
    galleryId: '017.jpg',
    image: `/images/gallery/large/017.jpg`,
    alt: 'Plakete od pleksiglasa izrađene po mjeri',
  },
];
